import { Typography } from "@mui/material";
import { Grid } from "../../basics/Grid";
import { IUserCardProps } from "./types";
import { stringAvatar } from "src/lib/utils/strToAvatar";
import { Avatar, Card } from "../../basics";

const UserCard = (props: IUserCardProps) => {
    // UserCard uses compact layout by default (suitable for AppBar)
    const avatarSize = props?.theme?.spacing(5) ?? 28; // px
    const cardSx = {
        marginRight: 0.5,
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 8px',
        ":hover":{
            cursor: 'pointer'
        }
    } as any;

    const nameVariant = 'body1';

    return (
        <Card sx={cardSx}>
            <Grid container alignItems="center" gap={1} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Grid item>
                    <Avatar src={props.avatarSrc} sx={{ width: avatarSize, height: avatarSize }}>
                        {stringAvatar(props.avatarName ?? props.userName)}
                    </Avatar>
                </Grid>
                <Grid item>
                    <Grid container direction="row" sx={{ minWidth: 0, gap: 2, alignItems: "center" }}>
                        <Typography variant={nameVariant as any} sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {props.userName}
                        </Typography>
                        <Typography variant="caption" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {props.userPosition}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    )
}

export { UserCard }